import { Component, OnInit, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule]
})
export class TextInputComponent implements OnInit {

    constructor() { }
    @Input() icon = '';
    @Input() label = '';
    @Input() appearance = 'outline';
    @Input() control = true;
    ngOnInit(): void {
    }
}
